import { render, staticRenderFns } from "./AuthLogin.vue?vue&type=template&id=2b542e29&scoped=true&lang=pug&"
import script from "./AuthLogin.vue?vue&type=script&lang=js&"
export * from "./AuthLogin.vue?vue&type=script&lang=js&"
import style0 from "./AuthLogin.vue?vue&type=style&index=0&id=2b542e29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b542e29",
  null
  
)

export default component.exports